var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
var Mail = function (_a) {
    var color = _a.color, background = _a.background, props = __rest(_a, ["color", "background"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "40", height: "40" }, props),
        React.createElement("g", { fill: "none" },
            React.createElement("circle", { cx: "20", cy: "20", r: "20", fill: background, className: "ic_background" }),
            React.createElement("path", { fill: color, className: "ic_filling", d: "M28.571 11.429c.902 0 1.633.73 1.633 1.632v13.061c0 .902-.73 1.633-1.633 1.633H11.43a1.633 1.633 0 0 1-1.633-1.633v-13.06c0-.902.73-1.633 1.633-1.633H28.57zM11.184 13.88v12.241c0 .136.11.245.245.245H28.57c.136 0 .245-.11.245-.245V13.888c-6.513 7.05-8.258 8.847-8.792 8.847-.534 0-2.291-1.802-8.84-8.854zm16.73-1.064H12.09a562.554 562.554 0 0 0 5.919 6.294 83.11 83.11 0 0 0 1.789 1.82l.225.216.223-.214a82.504 82.504 0 0 0 1.78-1.82c1.386-1.451 3.35-3.55 5.888-6.296z" }))));
};
Mail.defaultProps = {
    background: '#555',
    color: '#151515',
};
export default Mail;
//# sourceMappingURL=Mail.js.map